import { SxProps, Theme } from '@mui/material';

export const mainBoxStyles: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  flexShrink: '0',
  '&:hover svg': {
    color: 'customColors.blue.400',
  },
  '&:hover .MuiAvatar-root': {
    backgroundColor: 'customColors.blue.400',
  },
};

export const buttonStyles: SxProps<Theme> = {
  textTransform: 'none',
  marginLeft: '5px',
  padding: '8px 0px 8px 26px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: '12px',
  color: 'common.white',
  '@media (max-width:1580px)': {
    gap: '8px',
    padding: '8px 0px 8px 16px',
  },
  '@media (max-width:1390px)': {
    gap: '7px',
    padding: '8px 0px 8px 10px',
  },
};

export const avatarStyles: SxProps<Theme> = {
  width: 36,
  height: 36,
  backgroundColor: 'customColors.blue.100',
  transition: '.2s ease',
};

export const welcomeTextStyles: SxProps<Theme> = {
  fontSize: 12,
  color: 'common.white',
};

export const nameTextStyles: SxProps<Theme> = {
  fontSize: 14,
  fontWeight: '500',
  paddingRight: '18px',
  '@media (max-width:1390px)': {
    fontSize: 13,
  },
};

export const MenuDropdownStyles: SxProps<Theme> = {
  width: 240,
  '@media (max-width:1390px)': {
    width: 210,
  },
};
